/** Turns the identity service's Google answers into outcomes the facade can act on. */
export class GoogleSignInService {
    identityClient;
    returnAddressSource;
    constructor(identityClient, returnAddressSource) {
        this.identityClient = identityClient;
        this.returnAddressSource = returnAddressSource;
    }
    async fetchClientId() {
        const result = await this.identityClient.getGoogleSignInSettings({});
        if (result.success === undefined) {
            throw new Error('trip-os-identity gave no known answer to the Google settings request');
        }
        return result.success.clientId;
    }
    async signIn(idToken) {
        const returnTo = this.returnAddressSource.getReturnAddress();
        const request = { idToken };
        if (returnTo !== undefined) {
            request.returnTo = returnTo;
        }
        const result = await this.identityClient.signInWithGoogle(request);
        return this.describeSignIn(result);
    }
    describeSignIn(result) {
        let outcome;
        if (result.success !== undefined) {
            outcome = { kind: 'signed-in', redirectTo: result.success.redirectTo };
        }
        else if (result.unauthorized !== undefined || result.conflict !== undefined) {
            outcome = { kind: 'rejected' };
        }
        else {
            throw new Error('trip-os-identity gave no known answer to the Google sign-in');
        }
        return outcome;
    }
}
//# sourceMappingURL=GoogleSignInService.js.map